/* eslint-disable no-case-declarations */

import {
  LOADING_PLAYERS,
  LOADING_PLAYERS_SUCCESS,
  LOADING_PLAYERS_ERROR,

  ADDING_PLAYER,
  ADDING_PLAYER_SUCCESS,
  ADDING_PLAYER_ERROR,

  UPDATING_PLAYER,
  UPDATING_PLAYER_SUCCESS,
  UPDATING_PLAYER_ERROR,

  DELETING_PLAYER,
  DELETING_PLAYER_SUCCESS,
  DELETING_PLAYER_ERROR,

  UPDATING_PLAYER_CHECKS,
} from '../actions/players';
  
const initialState = {
  playerList: [],
  loading: false,
};
  
const PlayersReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_PLAYERS:
        return { ...state, loading: true };
  
      case LOADING_PLAYERS_SUCCESS:
        return {
          ...state,
          loading: false,
          playerList: action.payload,
        };

      case ADDING_PLAYER:
        return { ...state, loading: true };
  
      case ADDING_PLAYER_SUCCESS:
        return {
          ...state,
          loading: false,
          playerList: [...state.playerList, action.payload],
        };

      case UPDATING_PLAYER:
        return { ...state, loading: true };
  
      case UPDATING_PLAYER_SUCCESS:
        const player = action.payload;
        const newPlayers = state.playerList.map((obj) => {
          return player.id === obj.id ? player : obj;
        });
        return {
          ...state,
          loading: false,
          playerList: [...newPlayers]
        };

      case DELETING_PLAYER:
        return { ...state, loading: true };
  
      case DELETING_PLAYER_SUCCESS:
        return {
          ...state,
          loading: false,
          playerList: [...state.playerList.filter((obj) => obj.id !== action.payload.id)],
          //playerChecks: [...state.playerChecks.filter((id) => id !== action.payload.id)]
        };

      // case UPDATING_PLAYER_CHECKS:
      //   //console.log(action.payload)
      //   return {
      //     ...state,
      //     loading: false,
      //     playerChecks: [...action.payload],
      //   };

      default:
        return state;
    }
  };
  
  export default PlayersReducer;
  